export default function About() {
  return (
    <section id="about" className="portfolio__about portfolio__elem">
      <h2>Sobre mí</h2>
      <p>
        Aprendiz a tiempo completo, extremadamente curioso e inquieto. Perfeccionista incansable en lo que hago y optimista con mis objetivos. Motivado por construir mucho más que tecnología, con mucho más que un equipo de trabajo.
      </p>
    </section>
  );
}
